import apiClient from 'core/api';
import AuthService from 'core/auth';
import { PaginationConfig } from 'core/pagination-optimized/redux/types';
import { add, remove } from 'core/spinner/redux/actions';
import { addToaster } from 'core/toaster/redux/actions';
import { ToasterType } from 'core/toaster/redux/types';
import queryString from 'core/utils/query-string';

import { envs } from 'application/envHandler';
import { ApplicationState } from 'application/redux';
import {
  SUBSCRIPTIONS_CLEAR_CACHE,
  SUBSCRIPTIONS_FAILURE,
  SUBSCRIPTIONS_SEARCH,
  SUBSCRIPTIONS_SUCCESS,
  SubscriptionAction
} from './types';

function successSubscriptions(payload: any): SubscriptionAction {
  return {
    type: SUBSCRIPTIONS_SUCCESS,
    payload
  };
}

function failure(payload: any): SubscriptionAction {
  return {
    type: SUBSCRIPTIONS_FAILURE,
    payload
  };
}

export function clearCacheSubscriptions(): SubscriptionAction {
  return {
    type: SUBSCRIPTIONS_CLEAR_CACHE
  };
}

export function fetchSubscriptions(hhid: string, filter?: PaginationConfig) {
  return async (dispatch: Function, getState: () => ApplicationState) => {
    dispatch(add(SUBSCRIPTIONS_SEARCH, {}));
    await AuthService.refreshToken();
    apiClient
      .get(
        `${envs.REACT_APP_API_URL}/hhid/${hhid}/account/subscriptions?${queryString(
          filter,
          getState().application.offset
        )}`
      )
      .then(
        response => {
          dispatch(remove(SUBSCRIPTIONS_SEARCH));
          return dispatch(successSubscriptions(response.data));
        },
        rejection => {
          dispatch(
            addToaster({
              title: 'all_device_pages.menu_account',
              message: 'error_messages.VIPOC_ERROR_016',
              type: ToasterType.danger
            })
          );
          dispatch(remove(SUBSCRIPTIONS_SEARCH));
          return dispatch(failure(rejection));
        }
      );
  };
}
